export default __webpack_public_path__ + "static/media/Alibegović Abdel.455819fb.jpg";